<ngx-dropzone
  class="dropzone"
  [ngClass]="{ 'no-files-error': showNoFilesError }"
  [aria-label]="'dragAndDrop' | translate"
  [disabled]="shouldDisableDropzone()"
  (change)="onSelect($event)"
>
  <ngx-dropzone-label>
    <p class="drag-and-drop-text">{{ 'dragAndDropToUpload' | translate }}</p>
    <div class="separator">
      <div class="separator-line"></div>
      <span class="separator-text">{{ 'or' | translate }}</span>
      <div class="separator-line"></div>
    </div>
    <p-button
      type="button"
      class="browse-files-btn"
      variant="outlined"
      [label]="'browseFiles' | translate"
      [disabled]="shouldDisableDropzone()"
    ></p-button>
  </ngx-dropzone-label>
</ngx-dropzone>
@if (!uploadListReview) {
  <div class="buttons-container">
    <div class="dropzone-button">
      @if (accessWebScanning() && (ignoreScanPrivileges || hasScanPrivileges()) && !hideScanning) {
        <button
          type="button"
          class="dap-upload-scan-btn uploader-buttons scan-button"
          [disabled]="shouldDisableDropzone()"
          [ngClass]="{ 'no-files-error': showNoFilesError }"
          (click)="startScanProcess()"
        >
          <span class="button-icon-container">
            <i class="fa-solid fa-scanner-image"></i>
          </span>
          <span class="button-text">{{ 'scanDocumentsButton' | translate }}</span>
        </button>
      }
    </div>
  </div>
}

@if (shouldDisableDropzone()) {
  <app-loading-overlay [loadingMessage]="'uploading' | translate"></app-loading-overlay>
}

<app-web-scanning-dialog
  [(visible)]="showScanDialog"
  (filesScanned)="onScannedFiles($event)"
>
</app-web-scanning-dialog>
